import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HTime } from '@shared/src/datatypes/HTime';
import { IStandStillDto } from '@shared/src/dtos/incident/IStandStillDto';
import { Observable } from 'rxjs';

/**
 * Funcionalitat comuna quan s'està parat: indicar que s'ha punxat, ampliar el temps parat, reportar-ho de nou o
 * indicar que ja està arreglat (treu la marca d'estar parat). L'app (endpoints privats) i les pantalles externes
 * (endpoints oberts) en deriven; cadascuna amb els seus estils.
 */
@Component({
    template: ''
})
export abstract class SharedStandStillAbstractComponent implements OnInit {

    public readonly = false;
    public readonlySend = false;

    public comment: string;
    public iHavePricked: boolean;
    public time: HTime = HTime.buildByHoursAndMinutes(1, 0);
    public mintime = HTime.buildByHoursAndMinutes(0, 30);

    @Output() public refreshStandStill: EventEmitter<boolean> = new EventEmitter();

    /** Reporta que s'està parat o, si moreTime, amplia el temps de la incidència actual */
    protected abstract sendStandStill(standStill: IStandStillDto): Observable<boolean>;

    /** Indica que ja no s'està parat */
    protected abstract sendResolved(standStill: IStandStillDto): Observable<boolean>;

    protected abstract getRouteId(): number;
    protected abstract getPhaseId(): number;
    protected abstract getShipmentId(): number;

    public ngOnInit(): void {
        this.readonlySend = this.readonly;
    }

    public changeComment(value: string): void {
    }

    public onIHavePricked(): void {
        this.iHavePricked = !this.iHavePricked;
    }

    /** Actualitza la incidència actual d'estic parat sumant el temps indicat */
    public onMoreTime(): void {
        this.report(true);
    }

    /** Reportar és quan encara estem parats */
    public onReport(): void {
        this.report(false);
    }

    public onResolved(): void {
        this.send(this.sendResolved(this.getIStandStill(false)));
    }

    public isValid(): boolean {
        return this.getIStandStill(false).isValid();
    }

    public getIStandStill(moreTime: boolean): IStandStillDto {
        return IStandStillDto.build(this.getRouteId(), this.getPhaseId(), this.getShipmentId(), this.iHavePricked,
            this.comment, this.time, moreTime);
    }

    private report(moreTime: boolean): void {
        this.send(this.sendStandStill(this.getIStandStill(moreTime)));
    }

    private send(request: Observable<boolean>): void {
        if (this.readonlySend || !this.isValid() || request == null)
            return;

        this.readonlySend = true;
        request.subscribe(data => {
            this.readonlySend = this.readonly;
            if (data)
                this.refreshStandStill.next(true);
        }, () => {
            this.readonlySend = this.readonly;
        });
    }
}
